import * as React from 'react';

import { Typography } from 'components';
import { useStyles } from './TextError.styles';
import { useTranslation } from 'react-i18next';

type TextErrorProps = {
  text: string;
};

const TextError: React.FC<TextErrorProps> = ({ text }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  return (
    <Typography className={styles.root} color="error">
      {t(text)}
    </Typography>
  );
};

export default TextError;
